// extracted by mini-css-extract-plugin
module.exports = {"toggle_switch":"toggle_switch__RVGVu7CEl1Lhm","switch":"switch__OL0T+7xdPLSqc"};